<template>
  <div class="customer_center">
    <div class="container">
      <div class="search">
        <div></div>
        <div style="display: flex">
          <el-input
            style="width: 289px; height: 32px"
            placeholder="请输入客户名称、商务经理、客户经理"
            v-model="query.searchCondition"
            clearable
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              class="right_search"
              @click="search"
            ></el-button>
          </el-input>
        </div>
      </div>
      <div class="table">
        <el-table
          :data="tableData"
          style="width: 100%"
          :header-cell-style="{ color: '#333' }"
          @sort-change="sortChange"
        >
          <el-table-column label="客户编号" align="center" min-width="100">
            <template v-slot="{ row }">
              <div>
                {{ row.clueCode }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="客户名称" min-width="100" :show-overflow-tooltip="true">
            <template v-slot="{ row }">
              <div class="enterpriseName">
                {{ row.enterpriseName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="签约时间"
            align="center"
            sortable="custom"
            prop="签约时间"
            min-width="100"
          >
            <template v-slot="{ row }">
              <div>
                {{ row.establishTime }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="招聘潜力"
            align="center"
            sortable="custom"
            prop="招聘潜力"
            min-width="100"
          >
            <template v-slot="{ row }">
              <div>
                {{ row.recruitPotential }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="确定需求"
            align="center"
            sortable="custom"
            prop="确定需求"
            min-width="100"
          >
            <template v-slot="{ row }">
              <div>
                {{ row.confirmDemand }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="潜在需求"
            align="center"
            sortable="custom"
            prop="潜在需求"
            min-width="100"
          >
            <template v-slot="{ row }">
              <div>
                {{ row.concealDemand }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="商务经理" align="center" min-width="100">
            <template v-slot="{ row }">
              <div>
                {{ row.englishName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="客户经理" align="center" min-width="100">
            <template v-slot="{ row }">
              <div>
                <div
                  class="customer_manager"
                  v-if="!row.customerManager && updateHasPermission"
                  @click="setCustomerManager(row)"
                >
                  待分配
                </div>
                <div v-else>{{ row.customerManager }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="企业线索" align="center" min-width="100">
            <template v-slot="{ row }">
              <div class="examine_clue" @click="clickCompile(row)">查看线索</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="150">
            <template v-slot="{ row }">
              <div class="options">
                <!-- <div class="click" @click="uploadBtn(row)">上传附件</div> -->
                <div v-if="fileHasPermission" class="click" @click="downloadBtn(row)">
                  <span>附件下载{{ ' ' }}</span>
                  <span v-if="row.accessorys != null">({{ row.accessorys.length }})</span>
                  <span v-else>(0)</span>
                </div>
                <div v-if="editHasPermission" class="click" @click="clickToDetails(row)">编辑</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 分页器 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="query.pageNum"
        :page-sizes="[10, 30, 50]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 查看线索 -->
    <div class="dialog">
      <el-dialog @close="dialogClose" :visible.sync="dialogVisible" width="30%">
        <div class="dialogHead">
          <div class="line"></div>
          <div class="txt">查看线索</div>
        </div>
        <div class="form">
          <el-form ref="form" :rules="rules" :model="form" label-width="119px">
            <el-form-item label="企业logo：" prop="logo">
              <uploadLogo
                :imageShow.sync="form.logo"
                @uploadOneImgShow="uploadOneImgShow"
              ></uploadLogo>
            </el-form-item>

            <el-form-item label="企业简称：" prop="enterpriseAbbreviation">
              <el-input
                v-model="form.enterpriseAbbreviation"
                placeholder="请输入企业简称"
              ></el-input>
            </el-form-item>

            <el-form-item label="企业全称：" prop="enterpriseName">
              <el-input v-model="form.enterpriseName" placeholder="请输入企业全称"></el-input>
            </el-form-item>

            <el-form-item label="地点" prop="enterpriseName">
              <div class="position">
                <CascaderArea
                  :country="form.nation"
                  :province="form.province"
                  :city="form.city"
                  @searchArae="dialogSearchArae"
                ></CascaderArea>
              </div>
            </el-form-item>

            <el-form-item label="来源方式：" prop="sourceWay">
              <div class="sourceWay">
                <div
                  v-for="item in sourceWayList"
                  :key="item.id"
                  class="item"
                  :class="item.id == form.sourceWay ? 'activeSourceWay' : ''"
                  @click="clickSourceWay(item)"
                >
                  {{ item.value }}
                </div>
              </div>
            </el-form-item>

            <el-form-item label="线索信息员：" prop="clueMessenger">
              <el-input v-model="form.clueMessenger" placeholder="请输入线索信息员"></el-input>
            </el-form-item>

            <el-form-item label="商务经理：" prop="englishName" class="commercial_manager">
              <el-select
                v-model="form.englishName"
                @change="changeBusinessManager"
                placeholder="请选择"
              >
                <el-option-group v-for="group in options" :key="group.label" :label="group.label">
                  <el-option v-for="item in group.options" :key="item" :label="item" :value="item">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>

            <el-form-item label="进度" prop="schedule" class="commercial_manager">
              <el-select
                v-model="form.schedule"
                filterable
                placeholder="请选择"
                @change="changeSchedule"
              >
                <el-option
                  v-for="item in formScheduleList"
                  :key="item.value"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="优先级" prop="priority" class="commercial_manager">
              <el-select
                v-model="form.priority"
                filterable
                placeholder="请选择"
                @change="changePriority"
              >
                <el-option
                  v-show="item.id != null"
                  v-for="item in priorityList"
                  :key="item.value"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="button">
            <div class="add" @click="addClue">保存</div>
            <div class="cancel" @click="dialogVisible = false">取消</div>
          </div>
        </div>
      </el-dialog>
    </div>

    <!-- 选择客户经理弹窗 -->
    <div class="customer_manager_dialog">
      <el-dialog
        @close="customerManagerDialogClose"
        :visible.sync="customerManagerDialog"
        width="30%"
        top="40vh"
      >
        <div class="dialogHead">
          <div class="line"></div>
          <div class="txt">选择客户经理</div>
        </div>
        <div class="customer_manager_main">
          <div class="customer_manager_main_label">客户经理：</div>
          <el-select
            style="width: 258px"
            v-model="customerManagerValue"
            placeholder="请选择客户经理"
          >
            <el-option
              v-for="(item, index) in customerManagerOptions"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </div>
        <div class="button">
          <div class="add" @click="addCustomerManager">确定</div>
          <div class="cancel" @click="customerManagerDialog = false">取消</div>
        </div>
      </el-dialog>
    </div>
    <!-- 上传附件对话框 -->
    <!-- <el-dialog title="提示" :visible.sync="UploadDialogVisible" width="30%">
      <div class="upload">
        <el-upload action :on-remove="handleRemove" multiple :http-request="upload">
          <el-button size="medium" type="primary">点击上传</el-button>
        </el-upload>
      </div>
    </el-dialog> -->
  </div>
</template>
<script>
const defaultObject = Object.freeze({
  baseParam: {
    pageNum: 1,
    pageSize: 10
  },
  clueCode: '',
  order: 'desc',
  orderType: null,
  searchCondition: null //搜索关键字
})
const formObj = Object.freeze({
  accomplishProject: null, // 已完成项目id（,隔开）
  city: '', // 城市
  clueCode: null, // 线索编号
  clueMessenger: '', //   	线索信息员
  createName: '', // 	创建人名字
  createTime: null, //  创建时间
  enterpriseAbbreviation: '', // 企业简称
  enterpriseName: '', // 企业全称
  enterpriseSites: '', // 企业官网
  establishTime: null, // 成立时间
  logo: '', // 企业logo
  nation: '中国', // 国家
  prepare: null, // 会前准备
  prepareUrl: null, // 准备地址
  priority: '', // 优先级别
  province: '北京', // 省份
  schedule: '', // 进度  0->企业导入；1->关键人导入；2->链接方导入；3->企业对接；4->企业签约
  sourceWay: null, // 来源方式0->其他；1->菁锐大脑；2->人工导入；3->合作方提交；
  statisticsTime: null, // 线索各种数据新增时间
  updateName: null, // 修改人名字
  updateTime: null, // 修改时间
  englishName: null // 商务经理
})
const editObj = Object.freeze({
  clueCode: '', //线索编号
  customerManager: '' //客户经理
})
const uploadObj = Object.freeze({
  accessoryName: '', // 附件名称
  accessoryUrl: '', // 附件地址
  clueCode: '', //线索编号
  createName: '', //上传者
  createTime: '', //上传时间
  id: 0
})
import { getClient } from '@/api/projectCenter'
//  getCluePage,uploadAdmin,addAccessory
import { updateClue, getUser, fileDownload } from '@/api/businessCenter'
import CascaderArea from '@/components/CascaderArea'
import uploadLogo from '../clueCenter/components/uploadLogo.vue'
//  import UploadFile from '@/components/UploadFile.vue'
export default {
  components: {
    CascaderArea,
    uploadLogo
  },
  data() {
    return {
      uploadFile: { ...uploadObj },
      UploadDialogVisible: false, //上传附件对话框
      fileList: [],
      tableData: [], // 表格数据
      query: { ...defaultObject }, // 请求表格数据
      editForm: { ...editObj }, //编辑提交
      total: 0, // 总条数
      dialogVisible: false, // 查看线索 dialog
      customerManagerDialog: false, // 选择客户经理 dialog
      customerManagerValue: '', // 选择的客户经理
      // form  新增线索
      form: { ...formObj },
      rules: {
        enterpriseAbbreviation: [{ required: true, message: '请填写企业简称' }],
        sourceWay: [{ required: true, message: '请选择来源方式' }],
        clueMessenger: [{ required: true, message: '请输入线索信息员' }],
        englishName: [{ required: true, message: '请选择商务经理' }],
        schedule: [{ required: true, message: '请选择进度' }],
        priority: [{ required: true, message: '请选择优先级' }]
      },
      // form --> 来源方式
      sourceWayList: [
        {
          value: '菁锐大脑',
          id: '1'
        },

        {
          value: '人工导入',
          id: '2'
        },

        {
          value: '合作方提交',
          id: '3'
        },
        {
          value: '其他',
          id: '0'
        }
      ],
      options: [
        {
          label: '商务经理',
          options: []
        },
        {
          label: '其他经理',
          options: []
        }
      ],
      // form --> 进度
      formScheduleList: [
        {
          value: '企业导入',
          id: '0'
        },
        {
          value: '关键人导入',
          id: '1'
        },
        {
          value: '链接方导入',
          id: '2'
        },
        {
          value: '企业对接',
          id: '3'
        },
        {
          value: '企业签约',
          id: '4'
        }
      ],
      // 优先级
      priorityList: [
        {
          value: '不限',
          id: null
        },
        {
          value: '更高',
          id: '3'
        },
        {
          value: '高',
          id: '2'
        },
        {
          value: '中',
          id: '1'
        },
        {
          value: '低',
          id: '0'
        }
      ],
      // 客户经理下拉项
      customerManagerOptions: []
    }
  },
  computed: {
    Authorization() {
      return sessionStorage.getItem('token')
    },
    updateHasPermission() {
      const userPermissions = JSON.parse(sessionStorage.getItem('menuTree')).flatMap(
        (outerItem) => {
          return outerItem.children.map((item) => item.path)
        }
      )
      const hasPermission = userPermissions.includes('/clue/updateClue')
      return hasPermission
    },
    getHasPermission() {
      const userPermissions = JSON.parse(sessionStorage.getItem('menuTree')).flatMap(
        (outerItem) => {
          return outerItem.children.map((item) => item.path)
        }
      )
      const hasPermission = userPermissions.includes('/clue/getKeyPersons')
      return hasPermission
    },
    // /clue/updateClue
    editHasPermission() {
      const userPermissions = JSON.parse(sessionStorage.getItem('menuTree')).flatMap(
        (outerItem) => {
          return outerItem.children.map((item) => item.path)
        }
      )
      const hasPermission = userPermissions.includes('/clue/getClient')
      return hasPermission
    },
    fileHasPermission() {
      const userPermissions = JSON.parse(sessionStorage.getItem('menuTree')).flatMap(
        (outerItem) => {
          return outerItem.children.map((item) => item.path)
        }
      )
      const hasPermission = userPermissions.includes('/clue/fileDownload')
      return hasPermission
    }
  },
  watch: {},
  //方法集合
  methods: {
    //  弹出设置客户经理弹出
    async setCustomerManager(row) {
      this.editForm.clueCode = row.clueCode
      const { data: res } = await getUser()
      if (res.resultCode === 200) {
        this.customerManagerOptions = res.data.customerManager
      } else {
        this.$message.error('获取客户经理列表失败！')
      }
      this.customerManagerDialog = true
    },
    //  客户经理修改提交
    async addCustomerManager() {
      this.editForm.customerManager = this.customerManagerValue
      const { data: res } = await updateClue(this.editForm)
      if (res.resultCode === 200) {
        this.customerManagerDialog = false
        this.search()
      }
    },
    //预览
    //handlePreview() {},

    //删除
    handleRemove() {},

    // 前往详情页面
    clickToDetails(row) {
      this.$router.push({
        path: '/businessCenter/customerDetails',
        query: {
          clueCode: row.clueCode
        }
      })
    },
    async search() {
      const { data: res } = await getClient(this.query)
      if (res.resultCode == 200) {
        this.total = res.data.total
        this.tableData = res.data.list
      }
    },
    sortChange(column) {
      let prop = column.prop
      let order = column.order
      if (prop == '签约时间') {
        this.query.orderType = '0'
      } else if (prop == '招聘潜力') {
        this.query.orderType = '1'
      } else if (prop == '确定需求') {
        this.query.orderType = '2'
      } else if (prop == '潜在需求') {
        this.query.orderType = '3'
      }

      if (order == 'ascending') {
        this.query.order = 'asc'
      } else if (order == 'descending') {
        this.query.order = 'desc'
      } else if (order == null) {
        this.query.order = 'desc'
        this.query.orderType = null
      }
      this.search()
    },
    handleSizeChange(val) {
      this.query.baseParam.pageSize = val
      this.search()
      this.$message.success('查询成功')
    },
    handleCurrentChange(val) {
      this.query.baseParam.pageNum = val
      this.search()
      this.$message.success('查询成功')
    },
    // 新增显示弹出框关闭的回调
    dialogClose() {
      this.form = {
        accomplishProject: null, // 已完成项目id（,隔开）
        city: '', // 城市
        clueCode: null, // 线索编号
        clueMessenger: '', //   	线索信息员
        createName: '', // 	创建人名字
        createTime: null, //  创建时间
        enterpriseAbbreviation: '', // 企业简称
        enterpriseName: '', // 企业全称
        enterpriseSites: '', // 企业官网
        establishTime: null, // 成立时间
        logo: '', // 企业logo
        nation: '中国', // 国家
        prepare: null, // 会前准备  1. 会前准备  2 已通知 3.已有链接
        prepareUrl: null, // 准备地址
        priority: '', // 优先级别
        province: '北京', // 省份
        schedule: '', // 进度  0->企业导入；1->关键人导入；2->链接方导入；3->企业对接；4->企业签约
        sourceWay: null, // 来源方式0->其他；1->菁锐大脑；2->人工导入；3->合作方提交；
        statisticsTime: null, // 线索各种数据新增时间
        updateName: null, // 修改人名字
        updateTime: null, // 修改时间
        englishName: null // 商务经理
      }
      // console.log('关闭了')
    },
    // 图片上传路径长地址  logo
    uploadOneImgShow(value) {
      this.form.logo = value
    },
    // 新增 --> 地点
    dialogSearchArae(val) {
      // console.log(val)
      this.form.nation = val.country
      this.form.province = val.province
      this.form.city = val.city
    },
    // 选择来源方式
    clickSourceWay(item) {
      this.form.sourceWay = item.id
      // console.log(this.form.sourceWay)
    },
    // 商务经理选择
    changeBusinessManager() {
      // console.log(this.form.englishName)
    },
    // form --> 进度
    changeSchedule() {
      // console.log(this.form.schedule)
    },
    // form --> 优先级
    changePriority() {
      // console.log(this.form.priority)
    },
    //   编辑线索
    addClue() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          // 编辑
          const userName = sessionStorage.getItem('userName')
          this.form.updateName = userName
          const { data: res } = await updateClue(this.form)
          if (res.resultCode == 200) {
            this.$message.success('编辑成功')
            this.dialogVisible = false
            this.search()
          }
        }
      })
    },
    //  获取所有经理
    async getUserData() {
      const { data: res } = await getUser()
      // console.log(res)
      this.options[0].options = res.data.businessManager // 商务经理
      this.options[1].options = res.data.otherManagers // 其他经理
    },
    // 跳转到企业详情页  查找数据
    async clickCompile(row) {
      if (this.getHasPermission) {
        sessionStorage.setItem('row1', JSON.stringify(row))
        this.$router.push({
          path: '/businessCenter/clueCenter/clueParticulars',
          query: {
            row: JSON.stringify(row)
          }
        })
      } else {
        this.$message.warning('暂无权限')
      }
    },
    // 关闭选择客户经理弹窗
    customerManagerDialogClose() {},
    // 上传附件按钮
    /* uploadBtn(row) {
      this.UploadDialogVisible = true
      this.uploadFile.clueCode = row.clueCode
    }, */
    // 下载附件按钮
    downloadBtn(row) {
      if (row.accessorys != '' && row.accessorys != null) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        fileDownload({
          clueCode: row.clueCode
        })
          .then((result) => {
            loading.close()
            let blob = new Blob([result.data])
            let href = window.URL.createObjectURL(blob) // 创建新的URL表示指定的blob对象
            const a = document.createElement('a') // 创建a标签
            a.style.display = 'none'
            a.href = href // 指定下载'链接
            //const { data: result } = await selectDayNumber({ id: 3 })
            let date = new Date()
            let year = date.getFullYear()
            let month = date.getMonth() + 1
            month = month < 10 ? '0' + month : month
            let day = date.getDate()
            day = day < 10 ? '0' + day : day
            let hours = date.getHours()
            hours = hours < 10 ? '0' + hours : hours
            let minutes = date.getMinutes()
            minutes = minutes < 10 ? '0' + minutes : minutes
            //console.log(result, 'result', '' + year + month + day)
            a.download =
              '' + year + month + day + hours + minutes + '-' + row.enterpriseName + '.zip' //指定下载文件名
            //result.data +
            // a.download = "test.png";
            a.click() //触发下载
            window.URL.revokeObjectURL(a.href) //释放URL对象
            if (document.body.contains(a)) {
              document.body.removeChild(a) //释放标签
            }
            this.$message.success('下载附件成功！')
          })
          .catch((err) => {
            this.$message.error('下载附件失败！!')
          })
      } else {
        this.$message.warning('暂无附件，请先上传附件！')
      }
    }
    //上传文件
    /* async upload(file) {
      this.uploadFile.accessoryName = file.file.name
      let arr = []
      const form = new FormData()
      form.append('files', file.file)
      form.append('Authorization', this.Authorization)
      const { data: res } = await uploadAdmin(form)
      if (res.resultCode == 200) {
        this.uploadFile.accessoryUrl = res.data.fileLook[0]
        arr.push(this.uploadFile)
        const { data: res1 } = await addAccessory(arr)
        if (res1.resultCode === 200) {
          this.UploadDialogVisible = false
          this.$message.success('附件上传成功！')
        } else {
          this.$message.error('附件上传失败！')
        }
      } else {
        this.$message.error('333')
      }
    } */
  },

  created() {
    this.search()
  },
  mounted() {}
}
</script>
<style scoped lang="less">
.container {
  height: 82vh;
  overflow: scroll;
}
.pagination {
  width: 100%;
  text-align: center;
  margin: 10px 0 20px 0;
}
.customer_center {
  background-color: #fff;
  position: relative;
  .search {
    display: flex;
    justify-content: space-between;
    padding: 17px 246px 0;
    margin-bottom: 42px;
    /deep/.el-input__inner {
      width: 289px;
      height: 32px;
      line-height: 32px;
      border: 1px solid #17757a;
    }
    /deep/.el-input__suffix {
      transform: translateY(-3px);
    }
    .right_search {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 48px;
      height: 32px;
      color: #fff;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      background-color: #17757a;
    }
  }
  .table {
    padding: 0 15px;
    overflow: scroll;
    .enterpriseName {
      width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .examine_clue {
      color: #17757a;
      cursor: pointer;
    }
    .customer_manager {
      color: #17757a;
      cursor: pointer;
      text-decoration: underline;
    }
    .options {
      display: flex;
      justify-content: space-between;
    }
  }

  .customer_manager_dialog {
    /deep/.el-dialog__header {
      padding: 0;
    }
    /deep/.el-dialog__body {
      padding: 0 0 30px 0px;
    }
    /deep/.el-input__inner {
      width: 258px;
      height: 32px;
      line-height: 32px;
    }
    /deep/.el-select__caret {
      line-height: 32px;
    }
    .customer_manager_main {
      display: flex;
      height: 32px;
      margin-bottom: 28px;
      text-align: right;
      .customer_manager_main_label {
        line-height: 32px;
        width: 156px;
      }
    }
    .dialogHead {
      display: flex;
      align-items: center;
      height: 54px;
      padding-left: 16px;
      .line {
        width: 4px;
        height: 20px;
        background-color: #17757a;
        border-radius: 2px;
        margin-right: 8px;
      }
      .txt {
        color: #333333;
        font-size: 16px;
        font-weight: 700;
      }
    }
    .button {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      .add {
        color: #fff;
        width: 64px;
        height: 33px;
        background-color: #17757a;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        border-radius: 4px;
        cursor: pointer;
      }
      .cancel {
        color: #17757a;
        width: 64px;
        height: 33px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        border-radius: 4px;
        border: 1px solid #17757a;
        margin-left: 34px;
        cursor: pointer;
      }
    }
  }

  .dialog {
    /deep/.el-dialog__header {
      padding: 0;
    }
    /deep/.el-dialog__body {
      padding: 0 0 30px 0px;
    }
    /deep/.el-input__inner {
      // width: 354px;
      width: 78%;
    }
    @media (min-width: 1920px) {
      /deep/.el-input__inner {
        width: 354px;
      }
    }
    .position {
      /deep/.el-input__inner {
        width: 90px;
      }
      /deep/.middle-select {
        width: 90px !important;
      }
    }
    @media (max-width: 1366px) {
      .sourceWay {
        font-size: 12px !important;
        width: 98% !important;
      }
    }
    .commercial_manager {
      @media (max-width: 1366px) {
        /deep/.el-input__suffix {
          right: 46px;
        }
      }
    }

    .sourceWay {
      width: 355px;
      // width: 78%;
      height: 36px;
      border-radius: 4px;
      border: 1px solid #dcdee0;
      display: flex;
      color: #333333;
      font-size: 14px;
      overflow: hidden;

      .item {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      .activeSourceWay {
        background-color: #17757a;
        color: #fff !important;
      }
    }

    .dialogHead {
      display: flex;
      align-items: center;
      height: 54px;
      padding-left: 16px;
      .line {
        width: 4px;
        height: 20px;
        background-color: #17757a;
        border-radius: 2px;
        margin-right: 8px;
      }
      .txt {
        color: #333333;
        font-size: 16px;
        font-weight: 500;
      }
    }

    .button {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      .add {
        color: #fff;
        width: 64px;
        height: 33px;
        background-color: #17757a;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        border-radius: 4px;
        cursor: pointer;
      }
      .cancel {
        color: #17757a;
        width: 64px;
        height: 33px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        border-radius: 4px;
        border: 1px solid #17757a;
        margin-left: 34px;
        cursor: pointer;
      }
    }
  }
}
.upload {
  display: flex;
  justify-content: center;
}
.click {
  color: #17757a;
  cursor: pointer;
}

/* 媒体查询：自适应 */
// 1680x1050 (1680x889)
@media (max-width: 1682px) and (max-height: 890px) {
  .container {
    max-height: 81vh !important;
  }
}

// 1600x900 (1600x739)
@media (max-width: 1602px) and (max-height: 740px) {
  .container {
    max-height: 78vh !important;
  }
}

// 1366x768 (1366x607)
@media (max-width: 1368px) and (max-height: 608px) {
  .container {
    max-height: 73vh !important;
  }
}

// 1280x960 (1280x799)
@media (max-width: 1282px) and (max-height: 800px) {
  .container {
    max-height: 80vh !important;
  }
}

// 1280x800 (1280x639)
@media (max-width: 1282px) and (max-height: 640px) {
  .container {
    max-height: 74vh !important;
  }
}

// 1280x768 (1280x607)
@media (max-width: 1282px) and (max-height: 608px) {
  .container {
    max-height: 73vh !important;
  }
}

// 1280x720 (1280x599)
@media (max-width: 1282px) and (max-height: 600px) {
  .container {
    max-height: 71vh !important;
  }
}

// 1280x600 (1280x439)
@media (max-width: 1282px) and (max-height: 440px) {
  .container {
    max-height: 63vh !important;
  }
}

// 1152x864 (1152x703)
@media (max-width: 1153px) and (max-height: 704px) {
  .container {
    max-height: 77vh !important;
  }
}

// 1024x768 (1024x607)
@media (max-width: 1025px) and (max-height: 608px) {
  .container {
    max-height: 73vh !important;
  }
}

// 800x600 (800x439)
@media (max-width: 801px) and (max-height: 440px) {
  .container {
    max-height: 63vh !important;
  }
}
</style>
